/**
 * Gesturely — Public marketing-site constants.
 *
 * SAFE FOR THE CLIENT BUNDLE. No secrets, tokens, or price IDs here.
 * Paddle configuration lives exclusively in `src/config/paddle.ts` and is
 * driven by environment variables — do not duplicate any of it here.
 */

export const SITE = {
  productName: 'Gesturely',
  tagline: 'Your trackpad, programmable.',
  supportEmail: 'support@getgesturely.com',
  legalName: 'Maison Barkat LLC',
  legalAddress: [
    '30 N Gould St Ste N',
    'Sheridan, WY 82801',
    'United States',
  ],
  systemRequirement: 'Requires macOS 14 or later.',

  /** Cosmetic price label shown on marketing pages. Paddle remains the
   *  source of truth for the actual charge (see BuyPage / paddle.ts). */
  priceLabel: '$14.99',

  /** Final macOS installer served from the production website. */
  downloadUrl:
    'https://getgesturely.com/downloads/Gesturely-1.0.0-build4.dmg',
} as const
